import { IonContent } from '@ionic/react';
import React from 'react';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import { PAYMENT_SECTION_ID, SECOND_SELECT_PLAN_SECTION_ID } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { useAppModals } from '@/hooks/useAppModals';
import { CoinsPaywallModal } from '@/modals/CoinsPaywall';
import { webCampaign } from '@/modules/webCampaign';
import { PaywallAINumber } from '@/pages/Paywall/sections/AINumber';
import { PaywallGuaranteePeriod } from '@/pages/Paywall/sections/GuaranteePeriod';
import { SectionPaymentMethodSelection } from '@/pages/Paywall/sections/PaymentMethodSelection';
import { getTitleWithDialogue } from '@/utils/getTitleWithDialogue';
import { scrollToById } from '@/utils/scrollToById';

import { FixedTimer } from '../../components/FixedTimer';
import { SelectPlanComponentSelector } from '../../sections/SelectPlan/SelectPlanComponentSelector';
import { SectionHowItWorks } from '../V6/sections/HowItWorks';
import { SectionUsersReviews } from '../V6/sections/UsersReviews';

import {
  CompanyDetailsFooterWrapper,
  PageStyles,
  TitleStyles,
} from './FastPayTabs.styles';
import { SectionMainImage } from './sections/MainImage';

const PaywallFastPayTabs: React.FC = () => {
  const shouldShowFixedTimer =
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.FIXED_TIMER) ||
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.FIXED_TIMER_V2) ||
    webCampaign.setup.paywallNotes.includes(
      PAYWALL_NOTES.FIXED_TIMER_SECOND_PLAN,
    );

  const removeDialogueReferences = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.REMOVE_DIALOGUE_REFERENCES,
  );

  const shouldShowCoinsPaywallModal = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
  );

  const { show: showCoinsPaywallModal } = useAppModals('coinsPaywall');

  const mainTitle = getTitleWithDialogue({
    removeDialogueReferences,
    isLure: webCampaign.isPaywallLure(),
    titleStyle: TitleStyles,
  });

  const getButtonProps = (scrollToPayment: () => void) => ({
    text: 'GET PREMIUM',
    onClick: shouldShowCoinsPaywallModal
      ? () => showCoinsPaywallModal()
      : scrollToPayment,
  });

  return (
    <PageStyles
      theme={webCampaign.getStaticTheme()}
      hasFixedTimer={shouldShowFixedTimer}
    >
      {shouldShowFixedTimer && <FixedTimer />}

      <IonContent>
        <SectionMainImage />

        <SelectPlanComponentSelector
          title={null}
          vipTitle="One Day VIP"
          buttonProps={getButtonProps(() => scrollToById(PAYMENT_SECTION_ID))}
        />

        <PaywallAINumber />

        <SectionUsersReviews />

        <SectionHowItWorks />

        <SelectPlanComponentSelector
          title={mainTitle}
          vipTitle="One Day Premium"
          buttonProps={getButtonProps(() => scrollToById(PAYMENT_SECTION_ID))}
          sectionId={SECOND_SELECT_PLAN_SECTION_ID}
        />

        {!shouldShowCoinsPaywallModal && <SectionPaymentMethodSelection />}

        <PaywallGuaranteePeriod />
        {webCampaign.setup.paywallNotes.includes(
          PAYWALL_NOTES.SHOW_COMPANY_DETAILS_FOOTER,
        ) && (
          <CompanyDetailsFooterWrapper>
            <CompanyDetailsFooter />
          </CompanyDetailsFooterWrapper>
        )}
      </IonContent>

      {shouldShowCoinsPaywallModal && <CoinsPaywallModal />}
    </PageStyles>
  );
};

export default PaywallFastPayTabs;
